import { render, staticRenderFns } from "./walkbn.vue?vue&type=template&id=1e135cc6&"
import script from "./walkbn.vue?vue&type=script&lang=js&"
export * from "./walkbn.vue?vue&type=script&lang=js&"
import style0 from "./walkbn.vue?vue&type=style&index=0&id=1e135cc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports